import React from 'react';
import { I18n } from 'aws-amplify';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { BP_API } from '../../actions/bp/actions';

import LoggedPage from '../page-templates/loggedAdmin';

import Reports from './_reports';

const mapStateToProps = state => {
    return state;
};

const mapDispatchToProps = dispatch => {
    return {
        reports: data => {
            return dispatch(BP_API.reports(data));
        },

        // create_billing_installment: data => {
        //     return dispatch(BP_API.create_extra_billing_installment(data));
        // },
    };
};

class ReportsAdmin extends React.Component {

    constructor(props) {

        super();

        this.state = {
        };
    }

    render() {

        return (
            <LoggedPage {...this.props}>

                <nav className="breadcrumb is-medium" aria-label="breadcrumbs">
                    <ul>
                        <li><NavLink to="/admin" className="is-black">{I18n.get("Admin")}</NavLink></li>
                        <li className="is-active"><NavLink to="/bpool/relatorios" className="is-black">{I18n.get("Relatórios")}</NavLink></li>
                    </ul>
                </nav>

                <div className="columns">

                    <div className="column is-12">

                        <Reports {...this.props} />

                    </div>

                </div>

            </LoggedPage>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsAdmin);
